var ARStateMessage = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ar-state-message",attrs:{"ar-widget-id":"ar-state-message","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-state-message"}},[(_vm.hasIcon)?_c('ar-icon',_vm._b({class:['icon', _vm.type],attrs:{"name":_vm.iconNameMap[_vm.type]}},'ar-icon',_vm.iconPropsDecorated,false)):_vm._e(),_vm._v(" "),_c('ar-text',_vm._b({class:['msg', _vm.type, _vm.disableTextColor && 'no-color'],attrs:{"size":"xs","text":_vm.text,"allow-html":"","multiple-lines":""}},'ar-text',_vm.textProps,false))],1)},
staticRenderFns: [],
  name: 'StateMessage',
  props: {
    arWidgetMeta: String,
    type: {
      type: String,
      default: 'success',
      validator: (value) =>
        ['success', 'error', 'warning', 'general', 'information'].indexOf(value) !== -1,
    },
    text: {
      type: String,
      default: null,
    },
    disableTextColor: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    iconProps: {
      type: Object,
      default: () => ({}),
    },
    textProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      iconNameMap: {
        success: 'notification-success',
        error: 'notification-error',
        warning: 'notification-warning',
        general: 'notification-general',
        information: 'exclamation-mark',
      },
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `text=${this.text};`,
        `type=${this.type};`,
      ].join('');
    },
    iconPropsDecorated() {
      if (this.type === 'information') {
        return {
          width: '14px',
          height: '14px',
          wrapperStyle: {
            border: `1px solid ${this.$arStyle.color.purple500}`,
            borderRadius: '50%',
          },
          ...this.iconProps,
        };
      }
      return {
        width: '14px',
        height: '14px',
        ...this.iconProps,
      };
    },
  },
  mounted() {},
};

export default ARStateMessage;
